import { makeCall } from "./client";

export class BillingAPI {

  public getPlans(app: string, query: object = {}): Promise<any> {
    return makeCall(app, "get", `plans`, {app, ...query});
  }

  public getPlan(app: string, planId: number, planData: object){
    return makeCall(app, "get", `plans/${planId}`, planData);
  }

  public editPlan(app: string, planId: number, planData: object){
    return makeCall(app, "patch", `plans/${planId}`, planData);
  }

  public createPlan(app: string, planData: object = {}){
    return makeCall(app, "post", "plans", planData);
  }

  public getFeaturesForPlan(app: string, planId: number){
    return makeCall(app, "get", `plans/${planId}/features`, {});
  }

  public saveFeaturesForPlan(app: string, planId: number, features: object = {}){
    const data = {
      ...features,
      planId
    };
    return makeCall(app, "put", `plans/${planId}/features`, data);
  }

  
}


// WEBPACK FOOTER //
// ./src/api/billing.ts